<template>
  <div class="page-form">
    <div class="page-wrap"
         id="demo"
         ref="demo">
      <div class="page-head">
        <h3>服务申请表 Ⅱ</h3>
        <p>（日本）</p>
      </div>
      <i-form :label-width="120"
              label-position="right"
              class="label-font">
        <div class="page-body"
             style="margin-bottom:40px;">
          <Row :gutter="50"
               style="marginTop: 30px"
               class-name="rowWidth">
            <i-col span="12"
                   class-name="icolWidth width-style">
              <Form-item class="label-font"
                         label="Case#">
                <input class="flex"
                       type="text"
                       placeholder="由威马捷填写"
                       v-model="formData.case" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth width-style">
              <Form-item label="客户姓名">
                <input v-model="formData.formName"
                       class="flex"
                       ref="xmv"
                       id="id3"
                       type="text" />
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="50">
            <i-col span="24"
                   class-name="text-title">
              <i>需要办理医疗签证身份担保的人员：</i>
              <label class="label-with-radio">
                <input type="radio"
                       ref="br1"
                       value="1"
                       v-model="formData.br"
                       name="name" />本人
              </label>
              <label class="label-with-radio">
                <input type="radio"
                       ref="brpt1"
                       value="2"
                       v-model="formData.br"
                       id="id4"
                       name="name" />本人+陪同人员
                <input type="number"
                       min="2"
                       v-if="formData.br === '2'"
                       style="padding-left: 40px;"
                       ref="brptt"
                       @keyup="keyup($event)"
                       v-model="formData.num"
                       @inpnt="input"
                       class="peopleinput">
                <span v-if="formData.br === '2'" class="ren">人</span>
              </label>
            </i-col>

          </Row>

        </div>
        <div class="page-title">
          客户信息<i>*</i>
        </div>
        <div class="page-body"
             style="margin-bottom:34px;">
          <Row :gutter="50"
               class-name="rowWidth">
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="单位名称">
                <input class="form-in-input"
                       ref="dwmc"
                       id="id5"
                       type="text"
                       v-model="formData.dwmc1" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="地址">
                <input class="form-in-input"
                       ref="dz"
                       type="text"
                       v-model="formData.dz1" />
              </Form-item>
            </i-col>
          </Row>

          <Row :gutter="50"
               class-name="rowWidth">
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="职位">
                <input type="text"
                       ref="zw"
                       class="flex"
                       v-model="formData.zw1" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="电话">
                <input type="number"
                       ref="dh"
                       id="id7"
                       class="flex ivu-diy-input"
                       v-model="formData.dh1" />
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="50"
               class-name="rowWidth">
            <i-col span="12"
                   class-name="icolWidth bottom-style">
              <Form-item label="年收入">
                <i-input type="text"
                         v-model="formData.nsr"
                         class="flex">
                  <span slot="append">万人民币</span>
                </i-input>
              </Form-item>

            </i-col>
            <i-col span="12"
                   class-name="icolWidth bottom-style">
              <Form-item label="主要收入来源">
                <input type="text"
                       ref="zyly"
                       class="flex"
                       v-model="formData.zyly1" />
              </Form-item>
            </i-col>
          </Row>
          <p class="page-note">
            <span>未成年，无工作单位者及退休人员请在职位这一栏中注明个人情况。</span>
          </p>
          <div class="line"></div>
          <Row :gutter="50"
               class-name="line-heigth" id="id8">
            <i-col span="8">
              <label class="label-with-radio">是否有犯罪或被拘留前科</label>
            </i-col>
            <i-col span="12">
              <label class="label-with-radio">
                <input type="radio"
                       name="weather1"
                       value="1"
                       v-model="formData.weatherY1" />有
              </label>
              <label class="label-with-radio">
                <input type="radio"
                       value="0"
                       name="weather1"
                       v-model="formData.weatherY1" />无
              </label>
            </i-col>
          </Row>
          <Row :gutter="50"
               class-name="line-heigth">
            <i-col span="8">
              <label class="label-with-radio">是否来过日本</label>
            </i-col>
            <i-col span="12">
              <label class="label-with-radio">
                <input type="radio"
                       name="riben1"
                       value="1"
                       v-model="formData.ribenY1" />有
              </label>
              <label class="label-with-radio">
                <input type="radio"
                       name="riben1"
                       value="0"
                       v-model="formData.ribenY1" />无
              </label>
            </i-col>
          </Row>
          <Row :gutter="50"
               class-name="line-heigth">
            <i-col span="8">
              <label class="label-with-radio">是否被拒签过</label>
            </i-col>
            <i-col span="12">
              <label class="label-with-radio">
                <input type="radio"
                       name="juqian1"
                       value="1"
                       v-model="formData.juqianY1" />有
              </label>
              <label class="label-with-radio">
                <input type="radio"
                       name="juqian1"
                       value="0"
                       v-model="formData.juqianY1" />无
              </label>
            </i-col>
          </Row>
          <Row :gutter="50"
               class-name="line-heigth">
            <i-col span="8">
              <label class="label-with-radio">是否被强制离境过</label>
            </i-col>
            <i-col span="12">
              <label class="label-with-radio">
                <input type="radio"
                       name="lijing1"
                       value="1"
                       v-model="formData.lijingY1" />有
              </label>
              <label class="label-with-radio">
                <input type="radio"
                       name="lijing1"
                       value="0"
                       v-model="formData.lijingY1" />无
              </label>
            </i-col>
          </Row>
        </div>
        <div class="page-title">
          陪同人员1
        </div>

        <div class="page-body"
             style="margin-bottom:30px;">
          <Row :gutter="50"
               class-name="rowWidth">
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="姓名">
                <input class="form-in-input"
                       :disabled="formData.num < 2"
                       type="text"
                       v-model="formData.ptryxm2" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="性别">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 2"
                         name="sex"
                         value="0"
                         v-model="formData.sexM2" />男性
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 2"
                         name="sex"
                         value="1"
                         v-model="formData.sexM2" />女性
                </label>
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="出生年月日">
                <DatePicker type="date" :disabled="formData.num < 1" v-model="formData.csrq2" style="width: 310px;"></DatePicker>
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="与客户关系">
                <input class="form-in-input"
                       :disabled="formData.num < 1"
                       type="text"
                       v-model="formData.khgx2" />
              </Form-item>
            </i-col>

            <!--<i-col span="12"-->
                   <!--class-name="icolWidth">-->
              <!--<Form-item label="电话">-->
                <!--<input class="form-in-input ivu-diy-input"-->
                       <!--:disabled="formData.num < 2"-->
                       <!--type="number" style="width: 310px;"-->
                       <!--v-model="formData.khdh2"/>-->
              <!--</Form-item>-->
            <!--</i-col>-->
            <!--<i-col span="12"-->
                   <!--class-name="icolWidth">-->
              <!--<Form-item label="E-mail">-->
                <!--<input class="form-in-input"-->
                       <!--v-model="formData.email2"-->
                       <!--id="id6"-->
                       <!--:disabled="formData.num < 2"-->
                       <!--type="text" />-->
              <!--</Form-item>-->
            <!--</i-col>-->
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="电话">
                <input class="form-in-input ivu-diy-input"
                       :disabled="formData.num < 2"
                       type="text"
                       v-model="formData.khdh2" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="E-mail">
                <input class="form-in-input"
                       :disabled="formData.num < 2"
                       type="text"
                       id="id6"
                       v-model="formData.email2" />
              </Form-item>
            </i-col>

            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="主要生活来源">
                <input class="form-in-input"
                       :disabled="formData.num < 2"
                       type="text"
                       v-model="formData.shly2" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="现居住地址">
                <input class="form-in-input"
                       :disabled="formData.num < 2"
                       placeholder="详细填写到门牌号码"
                       type="text"
                       v-model="formData.jzdz2" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="工作单位">
                <input class="form-in-input"
                       :disabled="formData.num < 2"
                       type="text"
                       v-model="formData.gzdw2" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="职位">
                <input class="form-in-input"
                       :disabled="formData.num < 2"
                       type="text"
                       v-model="formData.zw12" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="公司电话">
                <input class="form-in-input ivu-diy-input"
                       :disabled="formData.num < 2"
                       type="number" style="width: 310px;"
                       v-model="formData.gsdh2"/>
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="年收入">
                <i-input type="text"
                         :disabled="formData.num < 2"
                         class="flex"
                         v-model="formData.nsr2">
                  <span slot="append">万人民币</span>
                </i-input>
              </Form-item>
            </i-col>
            <i-col span="24"
                   class-name="icolWidth">
              <Form-item label="公司地址">
                <input class="form-in-input"
                       :disabled="formData.num < 2"
                       type="text"
                       v-model="formData.gsdz2" />
              </Form-item>
            </i-col>
          </Row>
          <p class="page-note">
            <span>未成年，无工作单位者及退休人员请在职位这一栏中注明个人情况。</span>
          </p>
          <div class="person-weather">
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否有犯罪或被拘留前科</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 2"
                         name="weather2"
                         value="1"
                         v-model="formData.weatherY2" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 2"
                         name="weather2"
                         value="0"
                         v-model="formData.weatherY2" />无
                </label>
              </i-col>
            </Row>
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否来过日本</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 2"
                         name="riben2"
                         value="1"
                         v-model="formData.ribenY2" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 2"
                         name="riben2"
                         value="0"
                         v-model="formData.ribenY2" />无
                </label>
              </i-col>
            </Row>
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否被拒签过</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 2"
                         name="juqian2"
                         value="1"
                         v-model="formData.juqianY2" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 2"
                         name="juqian2"
                         value="0"
                         v-model="formData.juqianY2" />无
                </label>
              </i-col>
            </Row>
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否被强制离境过</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 2"
                         name="lijing2"
                         value="1"
                         v-model="formData.lijingY2" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 2"
                         name="lijing2"
                         value="0"
                         v-model="formData.lijingY2" />无
                </label>
              </i-col>
            </Row>
          </div>
        </div>
        <div class="page-title">
          陪同人员2
        </div>

        <div class="page-body"
             style="margin-bottom:30px;">
          <Row :gutter="50"
               class-name="rowWidth">
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="姓名">
                <input class="form-in-input"
                       :disabled="formData.num < 3"
                       type="text"
                       v-model="formData.ptryxm3" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="性别">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 3"
                         name="sex2"
                         value="0"
                         v-model="formData.sexM3" />男性
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 3"
                         name="sex2"
                         value="1"
                         v-model="formData.sexM3" />女性
                </label>
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="出生年月日">
                <DatePicker type="date" :disabled="formData.num < 3" v-model="formData.csrq3" style="width: 310px;"></DatePicker>
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="与客户关系">
                <input class="form-in-input"
                       :disabled="formData.num < 3"
                       type="text"
                       v-model="formData.khgx3" />
              </Form-item>
            </i-col>

            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="电话">
                <input class="form-in-input ivu-diy-input"
                       :disabled="formData.num < 3"
                       type="text"
                       v-model="formData.khdh3" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="E-mail">
                <input class="form-in-input"
                       :disabled="formData.num < 3"
                       type="text"
                       v-model="formData.email3" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="主要生活来源">
                <input class="form-in-input"
                       :disabled="formData.num < 3"
                       type="text"
                       v-model="formData.shly3" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="现居住地址">
                <input class="form-in-input"
                       :disabled="formData.num < 3"
                       placeholder="详细填写到门牌号码"
                       type="text"
                       v-model="formData.jzdz3" />
              </Form-item>
            </i-col>

            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="工作单位">
                <input class="form-in-input"
                       :disabled="formData.num < 3"
                       type="text"
                       v-model="formData.gzdw3" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="职位">
                <input class="form-in-input"
                       :disabled="formData.num < 3"
                       type="text"
                       v-model="formData.zw3" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="公司电话">
                <input class="form-in-input ivu-diy-input"
                       :disabled="formData.num < 3"
                       type="number" style="width: 310px;"
                       v-model="formData.gsdh3"/>
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="年收入">
                <i-input type="text"
                         :disabled="formData.num < 3"
                         class="flex"
                         v-model="formData.nsr3">
                  <span slot="append">万人民币</span>
                </i-input>
              </Form-item>
            </i-col>
            <i-col span="24"
                   class-name="icolWidth">
              <Form-item label="公司地址">
                <input class="form-in-input"
                       :disabled="formData.num < 3"
                       type="text"
                       v-model="formData.gsdz3" />
              </Form-item>
            </i-col>
          </Row>
          <p class="page-note">
            <span>未成年，无工作单位者及退休人员请在职位这一栏中注明个人情况。</span>
          </p>
          <div class="person-weather">
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否有犯罪或被拘留前科</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 3"
                         name="weather3"
                         value="1"
                         v-model="formData.weatherY3" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 3"
                         name="weather3"
                         value="0"
                         v-model="formData.weatherY3" />无
                </label>
              </i-col>
            </Row>
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否来过日本</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 3"
                         name="riben3"
                         value="1"
                         v-model="formData.ribenY3" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 3"
                         name="riben3"
                         value="0"
                         v-model="formData.ribenY3" />无
                </label>
              </i-col>
            </Row>
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否被拒签过</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 3"
                         name="juqian3"
                         value="1"
                         v-model="formData.juqianY3" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 3"
                         name="juqian3"
                         value="0"
                         v-model="formData.juqianY3" />无
                </label>
              </i-col>
            </Row>
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否被强制离境过</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 3"
                         name="lijing3"
                         value="1"
                         v-model="formData.lijingY3" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 3"
                         name="lijing3"
                         value="0"
                         v-model="formData.lijingY3" />无
                </label>
              </i-col>
            </Row>
          </div>
        </div>
        <div class="page-title">
          陪同人员3
        </div>
        <div class="page-body"
             style="margin-bottom:30px;">
          <Row :gutter="50"
               class-name="rowWidth">
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="姓名">
                <input class="form-in-input"
                       :disabled="formData.num < 4"
                       type="text"
                       v-model="formData.ptryxm4" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="性别">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 4"
                         name="sex3"
                         value="0"
                         v-model="formData.sexM4" />男性
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 4"
                         name="sex3"
                         value="1"
                         v-model="formData.sexM4" />女性
                </label>
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="出生年月日">
                <DatePicker type="date" :disabled="formData.num < 4" v-model="formData.csrq4" style="width: 310px;"></DatePicker>
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="与客户关系">
                <input class="form-in-input"
                       :disabled="formData.num < 4"
                       type="text"
                       v-model="formData.khgx4" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="电话">
                <input class="form-in-input ivu-diy-input"
                       :disabled="formData.num < 4"
                       type="text"
                       v-model="formData.khdh4" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="E-mail">
                <input class="form-in-input"
                       :disabled="formData.num < 4"
                       type="text"
                       v-model="formData.email4" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="主要生活来源">
                <input class="form-in-input"
                       :disabled="formData.num < 4"
                       type="text"
                       v-model="formData.shly4" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="现居住地址">
                <input class="form-in-input"
                       :disabled="formData.num < 4"
                       placeholder="详细填写到门牌号码"
                       type="text"
                       v-model="formData.jzdz4" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="工作单位">
                <input class="form-in-input"
                       :disabled="formData.num < 4"
                       type="text"
                       v-model="formData.gzdw4" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="职位">
                <input class="form-in-input"
                       :disabled="formData.num < 4"
                       type="text"
                       v-model="formData.zw4" />
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="公司电话">
                <input class="form-in-input ivu-diy-input"
                       :disabled="formData.num < 4"
                       type="number" style="width: 310px;"
                       v-model="formData.gsdh4"/>
              </Form-item>
            </i-col>
            <i-col span="12"
                   class-name="icolWidth">
              <Form-item label="年收入">
                <i-input type="text"
                         :disabled="formData.num < 4"
                         class="flex"
                         v-model="formData.nsr4">
                  <span slot="append">万人民币</span>
                </i-input>
              </Form-item>
            </i-col>
            <i-col span="24"
                   class-name="icolWidth">
              <Form-item label="公司地址">
                <input class="form-in-input"
                       :disabled="formData.num < 4"
                       type="text"
                       v-model="formData.gsdz4" />
              </Form-item>
            </i-col>
          </Row>
          <p class="page-note">
            <span>未成年，无工作单位者及退休人员请在职位这一栏中注明个人情况。</span>
          </p>
          <div class="person-weather">
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否有犯罪或被拘留前科</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 4"
                         name="weather4"
                         value="1"
                         v-model="formData.weatherY4" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 4"
                         name="weather4"
                         value="0"
                         v-model="formData.weatherY4" />无
                </label>
              </i-col>
            </Row>
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否来过日本</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 4"
                         name="riben4"
                         value="1"
                         v-model="formData.ribenY4" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 4"
                         name="riben4"
                         value="0"
                         v-model="formData.ribenY4" />无
                </label>
              </i-col>
            </Row>
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否被拒签过</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 4"
                         name="juqian4"
                         value="1"
                         v-model="formData.juqianY4" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 4"
                         name="juqian4"
                         value="0"
                         v-model="formData.juqianY4" />无
                </label>
              </i-col>
            </Row>
            <Row :gutter="50"
                 class-name="line-heigth">
              <i-col span="8">
                <label class="label-with-radio">是否被强制离境过</label>
              </i-col>
              <i-col span="12">
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 4"
                         name="lijing4"
                         value="1"
                         v-model="formData.lijingY4" />有
                </label>
                <label class="label-with-radio">
                  <input type="radio"
                         :disabled="formData.num < 4"
                         name="lijing4"
                         value="0"
                         v-model="formData.lijingY4" />无
                </label>
              </i-col>
            </Row>
          </div>
        </div>

      </i-form>

    </div>
    <div class="text-center">
      <button class="btn"
              @click="submit">提交</button>
    </div>
  </div>
</template>
<script>
  import * as apis from "@/api/other";
  import { verifyPhone, verifyEmail, verifyPassword } from "../../public/js/util.js";
  import $ from "jquery";
  export default {
    data () {
      return {
        username: "",
        form: {},
        id: 0,

        formHtmlOfSet: [],
        formHtmlOfPro: [],

        xmv: '', brpt1: '', brptt: '', br1: '',
        dwmc: '', dz: '', zw: '', dh: '', nsr: '', zyly: '',
        formName: '',
        br: '',
        num: '',
        email: '',
        formData: {}
      };
    },
    mounted () {
      let id = this.$route.params.hid;
      this.id = id;
      this.getFormTable(id);
      this.type = localStorage.getItem('hospital_type');
      //   this.getFormStep();
    },
    methods: {
      input() {
        if(this.num < 2) {
          this.num = 2
        }
      },
      //handleSubmit(e) {
      // let str = this.$refs.formValidate.innerHTML;
      // console.log(str)
      // let parent = e.currentTarget.parentsElement;
      // console.log(parent)
      // this.$nextTick(() => {
      //     let str = this.$refs.demo;
      // console.log(str)
      // })
      //},
      async getFormTable (id) {
        try {
          let data = {
            id
          };
          let res = await apis.getFormTablePart(data);
          if (res.code == 200) {
            this.formHtmlOfSet = res.data.plan;
            this.formHtmlOfPro = res.data.project;
          }
        } catch (e) {
          console.log(e);
        }
      },
      keyup(e) {
        if (!e.key || e.key === 'Backspace') return
        if (Number(e.key)) {
          if (Number(e.key) < 2) {
            this.num = 2
          }
        } else {
          this.num = 3
        }
      },
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(), // 年
          "m+": (date.getMonth() + 1).toString(), // 月
          "d+": date.getDate().toString(), // 日
          "H+": date.getHours().toString(), // 时
          "M+": date.getMinutes().toString(), // 分
          "S+": date.getSeconds().toString(), // 秒
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(
                 ret[1],
                 ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
            );
          }
        }
        return fmt;
      },
      async submit () {
        let arr = [];
        let arr2 = [];
        console.log(this.formData)
        if (!this.$refs.xmv.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入姓名',

              duration: 5000
            });
          }, 0)
          arr2.push('id3')
          arr.push(false)
        }
        if (!this.$refs.brpt1.checked && !this.$refs.br1.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '需要办理医疗签证身份担保的人员未选择',

              duration: 5000
            });
          }, 0)
          arr2.push('id4')
          arr.push(false)
        }
        if (this.$refs.brpt1.checked) {
          if (!this.$refs.brptt.value) {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: '请输入陪同人',

                duration: 5000
              });
            }, 0)
            arr2.push('id4')
            arr.push(false)
          }
        }

        if (!this.$refs.dwmc.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入单位名称',

              duration: 5000
            });
          }, 0)
          arr2.push('id5')
          arr.push(false)
        }
        if (this.formData.email && !verifyEmail(this.formData.email)) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '邮箱格式不正确！',

              duration: 5000
            });
          }, 0)
          arr2.push('id6')
          arr.push(false)
        }
        if (!this.$refs.dz.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入地址',

              duration: 5000
            });
          }, 0)
          arr2.push('id6')
          arr.push(false)
        }
        if (!this.$refs.zw.value) {

          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入职位',

              duration: 5000
            });
          }, 0)
          arr2.push('id6')
          arr.push(false)
        }
        if (!this.$refs.dh.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入电话',

              duration: 5000
            });
          }, 0)
          arr2.push('id7')
          arr.push(false)
        }
        if (!this.formData.nsr) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入年收入',

              duration: 5000
            });
          }, 0)
          arr2.push('id7')
          arr.push(false)
        }
        if (!this.$refs.zyly.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请输入主要收入来源',

              duration: 5000
            });
          }, 0)
          arr2.push('id7')
          arr.push(false)
        }
        if (!this.formData.weatherY1) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请选择是否有犯罪或被拘留前科',

              duration: 5000
            });
          }, 0)
          arr2.push('id8')
          arr.push(false)
        }
        if (!this.formData.ribenY1) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请选择是否来过日本',

              duration: 5000
            });
          }, 0)
          arr2.push('id8')
          arr.push(false)
        }
        if (!this.formData.juqianY1) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请选择是否被拒签过',

              duration: 5000
            });
          }, 0)
          arr2.push('id8')
          arr.push(false)
        }
        if (!this.formData.lijingY1) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: '请选择是否被强制离境过',

              duration: 5000
            });
          }, 0)
          arr2.push('id8')
          arr.push(false)
        }

        if(arr2.length) {
          window.scrollTo(0, (document.getElementById(arr2[0]).getBoundingClientRect().top + document.documentElement.scrollTop - 100))
        }
        if (arr.length) {
          return
        }

        if (this.formData.csrq2) {
          this.formData.csrq2 = this.dateFormat(
               "YYYY-mm-dd",
               this.formData.csrq2
          );
        }
        if (this.formData.csrq3) {
          this.formData.csrq3 = this.dateFormat(
               "YYYY-mm-dd",
               this.formData.csrq3
          );
        }
        if (this.formData.csrq4) {
          this.formData.csrq4 = this.dateFormat(
               "YYYY-mm-dd",
               this.formData.csrq4
          );
        }

        try {
          let data = {
            content: this.formData,
            hospital_id: this.id,
            name: this.formData.formName
          };
          let res = await apis.submitFormData(data);
          if (res.code == 200) {
            // console.log(res)
            this.$message({
              showClose: true,
              message: '提交成功！',
              type: 'success',
              duration: 5000
            });
            let form_id = res.data.id;
            localStorage.setItem("form_id", form_id);
            if (this.type.indexOf('4') > -1) {
              this.$router.push({ name: 'FormOfThree', params: { hid: this.id } });
            } else {
              // this.$router.push({
              //   name: "Upload",
              //   params: { form_id: form_id }
              // });
              localStorage.setItem('formLink', 'one')
              this.$router.push({
                path: "/myfile"
              });
            }
          } else {
            this.$message({
              showClose: true,
              message: '提交失败！',

              duration: 5000
            });
          }
        } catch (e) {
          console.log(e);
        }
      }
    }
  };
</script>
<style lang="less">
  /*在谷歌下移除input[number]的上下箭头*/
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }
  /*在firefox下移除input[number]的上下箭头*/
  input[type="number"] {
    -moz-appearance: textfield;
  }
  .ivu-form .ivu-form-item .ivu-form-item-label,
  .font-label {
    font-size: 18px;
    color: #000;
    padding-right: 10px;
  }
  ::v-deep #demo .ivu-form .ivu-form-item-label {
    padding: 10px 12px 10px 0!important;
  }
  .ivu-form-item-label {
    display: inline-block;
    width: 120px;
    font-size: 18px;
    font-weight: bold;
    color: #000;
    line-height: 40px;
  }
  .ivu-form-item-content {
    input[type='text'] {
      width: 100%;
      height: 40px;
      border: 1px solid #cacaca;
      font-size: 16px;
      color: #000;
      text-indent: 8px;
      outline: none;
    }
  }
  .page-form {
    background: #fff;
  }
  .page-wrap {
    width: 970px;
    border: 1px solid #dcdcdc;
    margin: 0 auto 30px;
  }
  .page-head {
    height: 80px;
    background: #ae1e10;
    color: #fff;
    text-align: center;
    margin-bottom: 34px;
    h3 {
      font-size: 30px;
      line-height: 50px;
    }
    p {
      font-size: 18px;
    }
  }
  .page-body {
    background: #fff;
    margin: 0 30px;
  }
  .page-line {
    margin-bottom: 24px;
  }
  .page-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    // margin: 0 30px;
  }
  .page-column {
    width: 50%;
    padding-left: 30px;
  }
  .page-cross {
    border-bottom: 1px dashed #e2e2e2;
    padding: 30px 0;
  }
  .page-border {
    border-bottom: 1px dashed #e2e2e2;
    padding: 30px 0;
  }
  .label-with-radio {
    display: inline-block;
    font-size: 12px;
    line-height: 40px;
    vertical-align: middle;
    margin: 0 10px;
    input[type='radio'] {
      vertical-align: middle;
      margin-right: 4px;
    }
  }
  .flex {
    width: 100%;
    // flex: 1;
  }
  .form-cell {
    // flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 15px 30px;
    label.form-label {
    }
    label.label-radio {
      display: inline-block;
      width: 80px;
      font-size: 18px;
      color: #000;
      line-height: 40px;
    }
  }
  .form-in-input {
    height: 40px;
    border: 1px solid #bababa;
    font-size: 18px;
    color: #000;
    text-indent: 8px;
    outline: none;
  }
  .form-input {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    input[type='text'] {
      // flex: 1;
      height: 40px;
      border: 1px solid #bababa;
      font-size: 18px;
      color: #000;
      text-indent: 8px;
      outline: none;
    }
  }
  .page-note {
    font-size: 14px;
    color: #000;
    line-height: 30px;
    color: #858585;
    &:before {
      display: inline-block;
      content: '\25A0';
      color: #ae1e10;
      font-size: 18px;
      margin-right: 10px;
      vertical-align: middle;
    }
    span {
      font-size: 14px;
      color: #000;
      line-height: 30px;
      vertical-align: middle;
    }
    margin: 2px 0 10px 0;
    i {
      color: #ae1e10;
    }
  }
  .line {
    margin-top: 22px;
    height: 16px;
    border-top: 1px dashed #e2e2e2;
  }

  .page-title {
    position: relative;
    height: 60px;
    font-size: 22px;
    color: #000;
    line-height: 60px;
    background: #f5f4f4;
    padding-left: 36px;
    margin: 10px 0px 35px 0px;
    font-weight: bold;
    i {
      color: #ae1e10;
    }
    &:before {
      position: absolute;
      left: 0;
      top: 0;
      content: '';
      display: block;
      width: 10px;
      height: 60px;
      background: #ae1e10;
    }
  }
  .page-stitle {
    font-size: 18px;
    color: #000;
    line-height: 40px;
  }
  .page-text {
    width: 100%;
    min-height: 130px;
    font-size: 16px;
    color: #000;
    line-height: 24px;
    border: 1px solid #bababa;
    outline: none;
    resize: none;
    padding: 10px;
  }
  .page-state {
    font-size: 15px;
    color: #000;
    line-height: 24px;
  }
  .btn {
    width: 200px;
    height: 50px;
    background: #ac4126;
    color: #fff;
    font-size: 20px;
    line-height: 40px;
    text-align: center;
    border: none;
    border-radius: 4px;
    margin-bottom: 50px;
  }
  .person-weather {
    border-top: 1px dashed #ccc;
    padding-top: 15px;
    margin-top: 10px;
  }
  .peopleinput {
    margin: 0px 10px;
    width: 110px;
    border: 1px solid #cacaca;
  }
  .ren {
    position: relative;
    top: 0px;
    left: -45px;
  }
  .ivu-form {
    padding-bottom: 20px;
  }

  ::-webkit-input-placeholder {
    color: #dcdcdc;
    font-size: 14px;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #dcdcdc;
    font-size: 14px;
  }
  　　 :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #dcdcdc;
    font-size: 14px;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #dcdcdc;
    font-size: 14px;
  }
</style>
<style lang="less" scoped>
  .line-heigth .label-with-radio {
    line-height: 24px;
    font-size: 14px;
    color: #000;
  }
  #demo .ivu-form .bottom-style .ivu-form-item {
    margin-bottom: 0 !important;
  }
  .text-title {
    i {
      font-size: 17px;
      color: #000;
      font-weight: bold;
      padding: 0;
      font-style: normal;
      display: block;
      float: left;
      height: 42px;
      line-height: 42px;
    }
  }
  .rowWidth .icolWidth .ivu-form-item .ivu-form-item-label {
    width: 110px !important;
  }
  .rowWidth .width-style .ivu-form-item .ivu-form-item-label {
    text-align: left;
    width: 100px !important;
  }
  .width-style {
    .ivu-form-item-content {
      margin-left: 100px !important;
    }
  }
  ::v-deep .label-with-radio {
    font-size: 18px!important;
    font-weight: 700;
  }
  .ivu-diy-input {
    height: 42px;
    border: 1px solid #cacaca;
    font-size: 14px;
    color: #000;
    text-indent: 8px;
    outline: none;
  }
</style>
